import styled from "styled-components";

export const PageContainer = styled.div`
  max-width: 100%;
  margin: 0 auto;
  padding: 20px;
  background: #f5f7fa;
  min-height: 100vh;

  @media (max-width: 1024px) {
    padding: 18px;
  }

  @media (max-width: 768px) {
    padding: 12px;
  }

  @media (max-width: 480px) {
    padding: 8px;
  }
`;

export const Header = styled.div`
  background: #203b34;
  border-radius: 12px;
  padding: 30px 40px;
  display: flex;
  align-items: center;
  gap: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;

  @media (max-width: 1024px) {
    padding: 24px 32px;
    gap: 16px;
    margin-bottom: 24px;
    border-radius: 10px;
  }

  @media (max-width: 768px) {
    padding: 16px 20px;
    gap: 12px;
    margin-bottom: 16px;
    border-radius: 8px;
    flex-wrap: wrap;
  }

  @media (max-width: 480px) {
    padding: 12px 16px;
    gap: 10px;
    margin-bottom: 12px;
    border-radius: 6px;
  }
`;

export const HeaderIcon = styled.div`
  width: 60px;
  height: 60px;
  background: #f9ae17;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: white;
  flex-shrink: 0;

  @media (max-width: 1024px) {
    width: 55px;
    height: 55px;
    font-size: 26px;
    border-radius: 10px;
  }

  @media (max-width: 768px) {
    width: 48px;
    height: 48px;
    font-size: 22px;
    border-radius: 8px;
  }

  @media (max-width: 480px) {
    width: 40px;
    height: 40px;
    font-size: 18px;
    border-radius: 6px;
  }
`;

export const HeaderContent = styled.div`
  flex: 1;
  min-width: 0;
`;

export const Title = styled.h1`
  color: white;
  margin: 0;
  font-size: 32px;
  font-weight: 600;
  line-height: 1.2;

  @media (max-width: 1024px) {
    font-size: 28px;
  }

  @media (max-width: 768px) {
    font-size: 22px;
  }

  @media (max-width: 480px) {
    font-size: 18px;
  }
`;

export const Subtitle = styled.p`
  color: rgba(255, 255, 255, 0.8);
  margin: 5px 0 0 0;
  font-size: 16px;
  line-height: 1.3;

  @media (max-width: 1024px) {
    font-size: 15px;
  }

  @media (max-width: 768px) {
    font-size: 13px;
    margin: 3px 0 0 0;
  }

  @media (max-width: 480px) {
    font-size: 12px;
    margin: 2px 0 0 0;
  }
`;

export const StatsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
  margin-bottom: 30px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 16px;
    margin-bottom: 24px;
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 12px;
    margin-bottom: 16px;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 10px;
    margin-bottom: 12px;
  }
`;

export const StatCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 25px 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border-left: 4px solid ${(props) => props.$color || "#3b82f6"};
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12);
  }

  @media (max-width: 1024px) {
    padding: 20px 24px;
    border-radius: 10px;
  }

  @media (max-width: 768px) {
    padding: 16px 20px;
    border-radius: 8px;

    &:hover {
      transform: translateY(-2px);
    }
  }

  @media (max-width: 480px) {
    padding: 12px 16px;
    border-radius: 6px;

    &:hover {
      transform: none;
    }
  }
`;

export const StatNumber = styled.div`
  font-size: 42px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 8px;

  @media (max-width: 1024px) {
    font-size: 38px;
    margin-bottom: 6px;
  }

  @media (max-width: 768px) {
    font-size: 32px;
    margin-bottom: 4px;
  }

  @media (max-width: 480px) {
    font-size: 26px;
    margin-bottom: 3px;
  }
`;

export const StatLabel = styled.div`
  font-size: 15px;
  color: #64748b;
  font-weight: 500;

  @media (max-width: 1024px) {
    font-size: 14px;
  }

  @media (max-width: 768px) {
    font-size: 13px;
  }

  @media (max-width: 480px) {
    font-size: 12px;
  }
`;

export const CalendarSection = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;

  @media (max-width: 1024px) {
    border-radius: 10px;
  }

  @media (max-width: 768px) {
    border-radius: 8px;
  }

  @media (max-width: 480px) {
    border-radius: 6px;
  }
`;
